// public-site/src/screens/Confirmation.js
// Payment receipt confirmation. Reassuring, plain-English, large type.

import React from 'react';
import { formatUSD } from '../api';
import { styles, colors } from '../theme';
import Brand from '../components/Brand';

// "2026-07-01" → "July 1, 2026" (parsed as local date to avoid TZ drift).
function formatDueDate(dateStr) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(dateStr || ''));
  if (!m) return '';
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}

export default function Confirmation({ payment, caseInfo, onPayAgain, onDone }) {
  const amount = payment?.amount;
  const receiptNumber = payment?.receiptNumber;
  const warning = payment?.warning;
  const upcoming = payment?.upcomingCharge;
  const upcomingDate = formatDueDate(upcoming?.nextDueDate);

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <Brand />
        <div
          style={{
            width: '68px',
            height: '68px',
            borderRadius: '50%',
            margin: '0 auto 14px',
            background: 'rgba(212,197,169,0.15)',
            border: `1px solid ${colors.hairline}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '34px',
            color: colors.gold,
          }}
        >
          ✓
        </div>
        <h1 style={{ ...styles.title, textAlign: 'center', color: colors.gold }}>
          Thank you
        </h1>
        <p style={{ ...styles.bodyText, textAlign: 'center' }}>
          Your payment of <strong>{formatUSD(amount)}</strong> was received.
        </p>

        <div
          style={{
            background: colors.nested,
            border: `1px solid ${colors.hairline}`,
            borderRadius: '12px',
            padding: '18px',
            margin: '8px 0 24px',
            textAlign: 'center',
          }}
        >
          <div style={{ ...styles.label, marginBottom: '6px' }}>Receipt number</div>
          <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: '20px', color: colors.white }}>
            {receiptNumber || '—'}
          </div>
          {caseInfo?.caseNumber && (
            <div style={{ ...styles.bodyText, fontSize: '16px', color: colors.textMuted, margin: '10px 0 0' }}>
              Case {caseInfo.caseNumber}
            </div>
          )}
        </div>

        {upcoming && upcomingDate && (
          <p style={{ ...styles.bodyText, textAlign: 'center', fontSize: '16px', color: colors.textSecondary }}>
            Your next automatic payment of {formatUSD(upcoming.amount)} is scheduled for {upcomingDate}.
          </p>
        )}

        {warning && <div style={styles.errorBox}>{warning}</div>}

        <button style={styles.buttonPrimary} onClick={onPayAgain}>
          View balance
        </button>
        <button
          style={{ ...styles.buttonSecondary, marginTop: '14px' }}
          onClick={onDone}
        >
          Done
        </button>
      </div>
    </div>
  );
}
